module.exports = __webpack_public_path__ + "static/img/newydz.b8be3d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newydz.png
// module id = 9Xbk
// module chunks = 1